import { GET_TRYST_HOST } from "../constants/env";
import fetchWrapper from "../fetch-client";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function deleteArchiveBusinessReceipt({
  receiptId,
  patientOid,
  abhaId,
}: {
  receiptId: string | number;
  patientOid?: string;
  abhaId?: string;
}): Promise<TrystGenericResponse<{ success: boolean }>> {
  const headers = new Headers();

  headers.append("accept", "application/json");
  headers.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers,
    credentials: "include",
  };

  const TRYST_HOST = GET_TRYST_HOST();
  const url = abhaId
    ? `${TRYST_HOST}/business/receipt/${receiptId}?abhaId=${abhaId}`
    : `${TRYST_HOST}/business/receipt/${receiptId}`;
  const response = await fetchWrapper(url, requestOptions);

  let archiveAppointmentResponse: TrystGenericResponse<{ success: boolean }> =
    await response.json();
  const { success, error } = archiveAppointmentResponse;

  if (!success) {
    throw new Error(error || "Failed to archive the receipt");
  }

  return { success: true };
}
